import { Question } from './Question';
import { DemographicOptionsViewModel } from './DemographicOptionsViewModel';

export class SurveyAssessmentViewModel {
    public name: string;
    public surveyID: number; // This is a lie. It's actually survey version ID!
    public surveyInstanceUniqueID: string;
    public questions: Question[];
    public completedDate: Date;
    public expired: boolean;

    public demographicOptions: DemographicOptionsViewModel;

    public unpaid: boolean;

    constructor() {
        this.questions = [];
    }
}


// WEBPACK FOOTER //
// ./src/models/SurveyAssessmentViewModel.tsx